<div fxLayout="row" fxLayoutAlign="center">
  <div fxLayout="column" fxFlex="80%">
        <mat-form-field>
          <mat-label>Select a category</mat-label>
          <mat-select (selectionChange)="showSection($event.value)">
            <mat-option
              *ngFor="let selction of faqSelection"
              [value]="selction.code"
            >
              {{ selction.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
    <section *ngIf="section === '1' || section === 'all'">
      <h5>EVERYDAY REWARDS PLUS CARD AND EVERYDAY REWARDS</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>What is Everyday Rewards? </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              When you activate your Everyday Rewards Plus Card, you'll
              automatically become a member of Everyday Rewards, the loyalty
              program where you simply boost, shop and enjoy.
            </p>
            <p>
              You’ll collect a minimum of 1 point for every<sup>^</sup> dollar
              you spend in store or online at Woolworths, BWS and BIG W
              Australia-wide, and at participating Caltex locations and Caltex
              Woolworths/EG (operated by Euro Garages Australia) in mainland
              Australia, and at other stores or businesses which may be
              advertised from time to time subject to any applicable terms and
              conditions. The Everyday Rewards points you collect will be
              rounded up to the nearest even number of points. You can enjoy
              your Everyday Rewards points as money off your shopping or
              convert them to Qantas Points.
            </p>
            <p>
              <sup>^</sup> You will not earn any points on smoking products,
              gift cards (including Woolworths WISH Gift Cards, e-gift cards
              and iTunes), mobile recharge, Woolworths Mobile, travel cards,
              tickets, cash outs, delivery charges, donations, Carpet Care,
              lottery, Pre-order Kiosks, BIG W Photos, BIG W eBay, lay-by fees
              and purchases using a Caltex StarCard, a Country Age Pension
              Fuel Card or on a charge account. Additional points exclusions
              for participating Caltex locations can be found at
              <a adhocenable="false" href="/terms.html"
                >everydayrewards.com.au/terms</a
              >. Please note that Caltex and Caltex Woolworths/EG (operated by
              Euro Garages Australia) located in Tasmania are currently
              excluded from the Everyday Rewards program.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What are the benefits of my Everyday Rewards Plus Card being
              linked to Everyday Rewards?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Because your Everyday Rewards Plus Card is linked to Everyday
              Rewards, you get automatic access to a whole range of fantastic
              benefits. This includes collecting points on every<sup>^</sup>
              dollar you spend to get money off a future shop, exclusive
              boosters, extras, favourites and more.
            </p>
            <p>
              <sup>^</sup> You will not earn any points on smoking products,
              gift cards (including Woolworths WISH Gift Cards, e-gift cards
              and iTunes), mobile recharge, Woolworths Mobile, travel cards,
              tickets, cash outs, delivery charges, donations, Carpet Care,
              lottery, Pre-order Kiosks, BIG W Photos, BIG W eBay, lay-by fees
              and purchases using a Caltex StarCard, a Country Age Pension
              Fuel Card or on a charge account. Additional points exclusions
              for participating Caltex locations can be found at
              <a adhocenable="false" href="/terms.html"
                >everydayrewards.com.au/terms</a
              >. Please note that Caltex and Caltex Woolworths/EG (operated by
              Euro Garages Australia) located in Tasmania are currently
              excluded from the Everyday Rewards program.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Where can I use my Everyday Rewards Plus Card and enjoy
              discounts?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              In store or online at Woolworths, BWS, BIG W, participating
              Caltex locations, Caltex Woolworths/EG (operated by Euro Garages
              Australia) and New Zealand Countdown stores.<br />
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What Everyday Rewards Plus Card discounts will I receive?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              You will receive:
            </p>
            <ul>
              <li>
                5% discount off your Woolworths shop, plus an additional 5%
                off selected Woolworths FoodCo brands (in store only)<sup
                  >*</sup
                >
              </li>
              <li>
                10% discount on purchases at BIG W in-store and online,
                excluding BIG W Photos online, Apple products, gaming
                consoles, existing lay-bys, rainchecks and any gift cards.
                Additional 10% discount at BIG W on a select range of men’s
                and women’s apparel and footwear (total 20% discount). See
                below for the full list of exclusions<sup>#</sup>.
              </li>
              <li>
                5% discount at BWS, plus an extra 5% off our Pinnacle Wine
                range (in store only) - look for an ‘E’ on the in-store
                tickets, and ‘bottled by Pinnacle Drinks’ on the back
                label<sup>+</sup>.
              </li>
              <li>
                4c per litre saving at participating Caltex or Caltex
                Woolworths/EG co-branded fuel outlets (operated by Euro
                Garages Australia)<sup>~</sup>. Look for the green "save 4c
                per litre" Woolworths Supermarkets branding on the petrol
                forecourt and/or the roadside price pylon.
              </li>
            </ul>
            <p>
              <sup>*</sup> 10% discount available on selected Woolworths
              FoodCo brands, exclusions apply. To see details of Woolworths
              FoodCo products that are included in the 10% discount,
              <a
                adhocenable="false"
                href="/content/dam/wowRewards/wowPeople/docs/Selected_Woolworths_FoodCo_Brands-5%25_off_in-store_only.pdf"
                target="_blank"
                >view the product list</a
              >. Offer available in-store only, not online.<br />
              <sup>#</sup> BIG W specific-exclusions: The BIG W 20% discount
              on select men’s and women’s apparel and footwear offer excludes
              the following items: sleepwear, swimwear, beachwear, underwear,
              socks, accessories (such as belts, hats, scarves, gloves, caps
              and ties) and kidswear. For the avoidance of doubt, the BIG W
              permanent 10% team discount remains in store and online for all
              other products excluding: BIG W Photos online, Apple products,
              gaming consoles, existing lay-bys, rainchecks and any gift
              cards. To redeem your offer online at
              <a
                adhocenable="false"
                href="https://www.bigw.com.au/"
                target="_blank"
                >bigw.com.au,</a
              >
              you will need to ensure your registered Everyday Rewards Plus
              Card number is linked to your online account at checkout.<br />
              <sup>+</sup> Look for the “E” on the price tickets in store,
              then look for ‘bottled by Pinnacle drinks’ on the label on the
              back of the bottle to identify a Pinnacle wine,
              <a
                adhocenable="false"
                href="/content/dam/wowRewards/wowPeople/images/PINNACLE_WINES.pdf"
                target="_blank"
                >view the product list</a
              >.&nbsp;Offer available in-store only, not online. Exclusions
              apply in Northern Territory.<br />
              <sup>~</sup>
              <a
                adhocenable="false"
                href="https://www.woolworths.com.au/shop/discover/petrol?name=wk41-petrol-4c-per-litre-offer&amp;cardId=13055"
                target="_blank"
                >View full terms &amp; conditions</a
              >. Please note that as a team member, you do not need to spend
              at least $30 in one transaction at a participating Woolworths
              Supermarket or Woolworths Metro in order to receive the 4 cents
              per litre fuel discount.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What if I'm already a Everyday Rewards member?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              We'll transfer your existing rewards to your new card - simply
              follow the prompts when activating your new Everyday Rewards
              Plus Card online. Your Everyday Rewards Plus Card will double as
              your Everyday Rewards card. Any points, fuel discounts or
              benefits earned on your old card will be transferred
              automatically to the new card. Be sure to destroy your existing
              Everyday Rewards card, as your new card replaces this.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What if I'd prefer not to join Everyday Rewards?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              You must be an Everyday Rewards member in order to access your
              team discount. If you'd prefer not to receive marketing
              communications from Everyday Rewards, you can manage your
              communication preferences via
              <a adhocenable="false" href="/">www.everydayrewards.com.au</a>
              or the Customer Hub on 1300 101 234, Option 1.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What happens if I leave Woolworths?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              The Everyday Rewards Plus Card is the property of Woolworths
              Group Limited. The Primary Card and any Secondary Card must be
              returned to Woolworths Group or if directed, destroyed by the
              cardholder when the Team Member ends employment with Woolworths.
              Upon the ending of your employment with Woolworths, your
              Everyday Rewards Plus Card will be cancelled and you'll receive
              a Everyday Rewards card instead.<br />
              <br />
              Any points and fuel discounts you may have earned will be
              automatically transferred to your new Everyday Rewards card.
              Don't forget to update your email and postal address if you've
              been using your Woolworths address to receive our updates so you
              don't miss out on your points boosters, extras and favourites.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Who do I contact if I have a problem or question?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Please contact the Customer Hub on 1300 101 234, Option 1, or
              via email and live web chat at
              <a adhocenable="false" href="/">www.everydayrewards.com.au</a>.
              The team is available 9am-7pm on weekdays and 10am-4pm on
              weekends (AEST).
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '2' || section === 'all'">
      <h5>ACTIVATION AND REGISTRATION PROCESS</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Do I need to activate my Everyday Rewards Plus Card to access
              Everyday Rewards?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Yes, you will need to activate your Everyday Rewards Plus Card
              to access the benefits of the Everyday Rewards program and to
              receive exclusive boosters.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Where do I find my Employee Number/ID?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Your Employee Number or Employee ID can be found on your
              payslip; it can also be located on the letter that was attached
              to your Everyday Rewards Plus Card.<br />
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >My details on the confirmation page are incorrect. What do I
              do?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If any details are incorrect, please update with the correct
              details and press submit. You can update your details at any
              time by logging into
              <a adhocenable="false" href="/">www.everydayrewards.com.au</a
              >.<br />
              <br />
              For further assistance please reach out to the Customer Hub on
              1300 101 234, Option 1, or via email and live web chat at
              <a adhocenable="false" href="/">www.everydayrewards.com.au</a>.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Why are you asking for my email address?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              As someone who has an Everyday Rewards Plus Card, you’ll be sent
              exclusive boosters, extras, favourites, competitions and other
              marketing and promotional messages from time to time.<br />
              <br />
              If you would like to opt out of receiving certain types of
              marketing and promotional messages from Everyday Rewards via
              email, you can do this by:
            </p>
            <ul>
              <li>
                logging on to the Everyday Rewards website, going to My
                Account and updating your settings to opt in or out of
                receiving marketing and promotional emails about different
                preferences (eg Everyday Rewards Plus) or unsubscribing from
                marketing and promotional emails altogether
              </li>
              <li>
                clicking unsubscribe in any marketing or promotional emails we
                send you, in which case you may choose to:
              </li>
            </ul>
            <p style="margin-left: 80px">
              -&nbsp;unsubscribe from receiving further marketing and
              promotional emails sent to that preference group (eg Woolworths
              Supermarkets)
            </p>
            <p style="margin-left: 80px">
              -&nbsp;update your settings to opt in or out of receiving
              marketing and promotional emails about different preferences (eg
              BIG W)
            </p>
            <p style="margin-left: 80px">
              -&nbsp;unsubscribe from marketing and promotional emails
              altogether
            </p>
            <ul>
              <li>
                calling the Customer Hub on 1300 101 234, Option 1, and
                letting us know what communications you no longer want to
                receive (if we can’t do it for you, we can certainly help walk
                you through the process).
              </li>
            </ul>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What if I already have a Everyday Rewards
              card?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If you already have a Everyday Rewards card, this will be
              replaced by your Everyday Rewards Plus Card. All of your
              existing fuel offers and linked cards for fuel offers, as well
              as your points balance, will automatically transfer over to your
              new Everyday Rewards Plus Card number. Once you have your
              Everyday Rewards Plus Card, please destroy and securely dispose
              of your Everyday Rewards card.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What if I’m already a Woolworths Everyday / Woolworths Qantas
              Credit Card customer?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              New team members will need to link their card with their
              Everyday Rewards Plus Card. Existing team members who have
              already linked their card will not need to do anything.<br />
              <br />
              You will receive a new Everyday Rewards Plus Card in the mail.
              This can be used to access your team member discount, as well as
              all the benefits of Everyday Rewards. Your Everyday Rewards Plus
              Card will need to be activated. Please note your credit card
              will not be attached to Everyday Rewards. You will need to reach
              out to the Woolworths Credit Cards team on 1300 10 1234 to
              ensure that your new Everyday Rewards Plus Card number is linked
              to your Woolworths Credit Card account.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What if my Everyday Rewards Plus Card doesn’t
              work?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Your new card must be activated before any team member benefits
              apply. If your Everyday Rewards Plus Card is not working, please
              call the Customer Hub on 1300 101 234, Option 1, or via email
              and live web chat at
              <a adhocenable="false" href="/">www.everydayrewards.com.au</a>.
              The team is available 9am-7pm on weekdays and 10am-4pm on
              weekends (AEST).
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '3' || section === 'all'">
      <h5>SECONDARY CARD</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >How do I order a Secondary Everyday Rewards Plus
              Card?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If this is the first time you are requesting a secondary
              Everyday Rewards Plus Card please
              <a
                href="http://203.39.219.157/hrportal-web/external/registrationForm.html"
                target="_blank"
                >click here</a
              >. If you need to order a replacement primary or secondary
              Everyday Rewards Plus Card please
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScigln7tiaqusq0agi59M3uyu1f7ek01Vr5Tyti3nptuV6hdA/viewform"
                target="_blank"
                >click here</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >How do I activate a Secondary Everyday Rewards Plus
              Card?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              You must activate your own Primary Everyday Rewards Plus Card
              first, before you can activate your Secondary card. To activate
              your Secondary card, simply follow the same steps that you did
              to register your new Everyday Rewards Plus Card. Please remember
              to enter your family member’s card number in the “Everyday
              Rewards Plus Card number” field, along with your employee
              number. Ensure you have the consent of your family member prior
              to activating their card.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Do Secondary Everyday Rewards Plus cardholders need to activate
              their card in order to be eligible for Everyday
              Rewards?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Yes, they too must activate to be eligible to access Everyday
              Rewards using their Everyday Rewards Plus Card.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Will my Everyday Rewards account be linked to my Secondary
              cardholder’s account?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              No. When activating your Secondary Everyday Rewards Plus Card,
              your Secondary cardholder will create their own Everyday Rewards
              account.
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '4' || section === 'all'">
      <h5>REPLACEMENT CARD</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >How do I order a replacement Primary or Secondary Everyday
              Rewards Plus Card?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If you need to order a replacement Primary or Secondary Everyday
              Rewards Plus Card, please
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScigln7tiaqusq0agi59M3uyu1f7ek01Vr5Tyti3nptuV6hdA/viewform?usp=sf_link"
                target="_blank"
                >click here</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Will my points balance transfer to my new
              card?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Yes, simply follow the prompts when activating your new card
              online. For further assistance, please reach out to the Customer
              Hub on 1300 101 234, Option 1, or via email and live web chat at
              <a adhocenable="false" href="/">www.everydayrewards.com.au</a>.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What should I do with my old card?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If you still have your old card, it’s best to cut it in half so
              it can no longer be scanned then securely dispose of it.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Can I replace a lost or stolen Everyday Rewards Plus Card
              online?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Yes you can. Complete an Everyday Rewards Plus Card Application.
              Please
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScigln7tiaqusq0agi59M3uyu1f7ek01Vr5Tyti3nptuV6hdA/viewform"
                target="_blank"
                >click here</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '5' || section === 'all'">
      <h5>WOOLWORTHS FOODCO PRODUCTS</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What Woolworths FoodCo products are included?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              For details of Woolworths FoodCo products that are included in
              the extra 5% discount (in store only),
              <a
                href="/content/dam/wowRewards/wowPeople/images/Selected_Woolworths_FoodCo_Brands-5percentage_off_in-store_only.pdf"
                target="_blank"
                >click here</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '6' || section === 'all'">
      <h5>PINNACLE DRINK PRODUCTS</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What Pinnacle Drink products are included?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              For details of Pinnacle Drink products that are included in the
              extra 5% discount (in store only),
              <a
                href="/content/dam/wowRewards/wowPeople/images/PINNACLE_WINES.pdf"
                target="_blank"
                >click here</a
              >.
            </p>
            <p>&nbsp;</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '7' || section === 'all'">
      <h5>FUEL OFFERS</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What fuel savings are Everyday Rewards Plus cardholders
              entitled to?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Receive 4c per litre off the pump price on fuel purchases up to
              150 litres per transaction at participating Caltex or and Caltex
              Woolworths/EG (operated by Euro Garages Australia). Look for the
              green "save 4c per litre" Woolworths Supermarkets branding on
              the petrol forecourt and/or the roadside price pylon. You can
              also receive an instant 4c per litre saving, if you spend $5 or
              more on in-store items at Caltex Woolworths/EG (operated by Euro
              Garages Australia) when you buy your fuel. Discounts do not
              apply on any Caltex StarCard purchases. To find out more about
              the fuel savings offer, Terms and Conditions and details of
              participating sites,
              <a
                href="https://www.woolworths.com.au/shop/discover/petrol?name=petrol-offer-8&amp;cardId=4854"
                target="_blank"
                >click here</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '8' || section === 'all'">
      <h5>MOBILE AND ONLINE ACCOUNTS</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >How do I update my new card number in the Woolworths
              App?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              (1) Press the Woolworths icon to open the app<br />
              (2) Click on the side navigation which can be accessed by
              clicking the button with the three horizontal lines<br />
              (3) Select the MORE button at the bottom of the list<br />
              (4) Click on the Settings tab, then click Logout of your
              Everyday Rewards Login<br />
              (5) Once logged out, click the Login button, then either enter
              your new card number or scan the barcode and press register. The
              App should update with your new details. All your existing
              boosters will now display under your new card number.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Can I add my Everyday Rewards Plus Card to my Digital
              Wallet?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Yes. Your Everyday Rewards Plus Card can be added to iPhone 6 or
              later, all Apple Watches running iOS 9 and above, and Android
              smartphones with NFC and Kitkat 4.4 or later. To find out more
              and directions on how to upload your card
              <a
                href="https://www.woolworths.com.au/shop/discover/woolworths-rewards/digital-wallet"
                target="_blank"
                >click here</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Can I tap my card at the registers by using a digital
              wallet?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Yes, you can tap your Everyday Rewards Plus Card in your Digital
              Wallet at Woolworths, BWS and BIG W.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >How do I update my new card number in my Woolworths Online
              account?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Go to the My Account section of the website and update your new
              card number.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Do I need to update my card number in my Everyday Rewards
              account online?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              No. This will be done automatically when you activate your card.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Do I need to update my card number in my BIG W, BWS, Woolworths
              Online or Cellarmasters online accounts?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If you are a new team member of Woolworths and have received
              your new Everyday Rewards Plus Card, you will need to activate
              your new card and enter your new card number in the My Account
              section of the relevant website.
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="section === '9' || section === 'all'">
      <h5>PRIVACY AND OPT-OUT PREFERENCES</h5>
      <mat-accordion [togglePosition]="'before'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What if I don’t want to join the Everyday Rewards
              program?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              All new starters and Woolworths Group Team Members must be an
              Everyday Rewards member in order to access their team
              discount.<br />
              If you would like to opt out of receiving certain types of
              marketing and promotional messages from Everyday Rewards via
              email, SMS or mail, you can do this by:
            </p>
            <ul>
              <li>
                logging on to the Everyday Rewards website, going to My
                Account and updating your settings to opt in or out of
                receiving marketing and promotional emails, SMSs or mail about
                different preferences (eg Everyday Rewards Plus) or
                unsubscribing from marketing and promotional emails, SMSs or
                mail altogether.
              </li>
              <li>
                clicking unsubscribe in any marketing or promotional emails we
                send you, in which case you may choose to:
              </li>
            </ul>
            <p style="margin-left: 80px">
              -&nbsp;unsubscribe from receiving further marketing and
              promotional emails, SMSs or mail sent to that preference group
              (eg Woolworths Supermarkets)
            </p>
            <p style="margin-left: 80px">
              -&nbsp;update your settings to opt in or out of receiving
              marketing and promotional emails, SMSs or mail about different
              preferences (eg BIG W)
            </p>
            <p style="margin-left: 80px">
              -&nbsp;unsubscribe from marketing and promotional emails, SMSs
              or mail altogether
            </p>
            <ul>
              <li>
                sending “STOP” to the number we provide you on any of our
                marketing or promotional SMSs so that you don’t receive
                marketing or promotional SMSs from us anymore
              </li>
              <li>
                calling the Customer Hub on 1300 101 234, Option 1, and
                letting us know what communications you no longer want to
                receive (if we can’t do it for you, we can certainly help walk
                you through the process).
              </li>
            </ul>
            If you would like to opt out of receiving certain marketing and
            promotional messages from Everyday Rewards via in-app
            notifications and advertising on certain websites and social
            media, you can turn off notifications on your mobile device or
            change your privacy settings online so you no longer receive app
            notifications or targeted advertising. View our Privacy Policy for
            further information.
            <p>&nbsp;</p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >I don't want to receive emails for special Team Member only
              offers. What do I do?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If you would like to opt out of receiving marketing and
              promotional messages from Everyday Rewards Plus via email, you
              can do this by logging on to the Everyday Rewards website, going
              to My Account and updating your settings to opt out of receiving
              marketing and promotional emails about Everyday Rewards Plus or
              unsubscribing from marketing and promotional emails
              altogether.<br />
              <br />
              You can also opt out of receiving marketing and promotional
              messages from Everyday Rewards Plus via email by clicking
              “unsubscribe” in any marketing or promotional emails we send you
              about Everyday Rewards Plus.<br />
              <br />
              In the alternative you can call the Customer Hub on 1300 101
              234, Option 1, and let us know what communications you no longer
              want to receive (if we can’t do it for you, we can certainly
              help walk you through the process).
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>How do I stop receiving emails?</mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              If you would like to opt out of receiving certain types of
              marketing and promotional messages from Everyday Rewards via
              email, you can do this by:
            </p>
            <ul>
              <li>
                logging on to the Everyday Rewards website, going to My
                Account and updating your settings to opt in or out of
                receiving marketing and promotional emails about different
                preferences (eg Everyday Rewards Plus) or unsubscribing from
                marketing and promotional emails altogether.
              </li>
              <li>
                clicking unsubscribe in any marketing or promotional emails we
                send you, in which case you may choose to:
              </li>
            </ul>
            <p style="margin-left: 80px">
              -&nbsp;unsubscribe from receiving further marketing and
              promotional emails sent to that preference group (eg Woolworths
              Supermarkets)
            </p>
            <p style="margin-left: 80px">
              -&nbsp;update your settings to opt in or out of receiving
              marketing and promotional emails about different preferences (eg
              BIG W)
            </p>
            <p style="margin-left: 80px">
              -&nbsp;unsubscribe from marketing and promotional emails
              altogether.
            </p>
            <ul>
              <li>
                calling the Customer Hub on 1300 101 234, Option 1, and
                letting us know what communications you no longer want to
                receive (if we can’t do it for you, we can certainly help walk
                you through the process).
              </li>
            </ul>
            <p>&nbsp;</p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What information are you collecting about me?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              When you sign up for the Everyday Rewards Plus Card, we will use
              your email address to send you offers. We collect personal
              information about how you shop so we can provide a better
              service to you. When shopping in store, or online, your Everyday
              Rewards membership helps us paint a more complete picture of you
              as our customer. We use this to promote our goods and services
              to you in a way which may be of most interest to you, to improve
              on the range of our offerings and to reward you with member
              benefits and send you offers on the things you like. You have
              control of your personal information: you have legal rights to
              access it and update it. If you are unhappy with the way we are
              managing your information, just let us know. You can be sure
              that any personal information you share with us is fully covered
              by our Privacy Policy. Details of the Everyday Rewards Privacy
              Policy are available
              <a
                href="https://www.woolworthsrewards.com.au/privacy.html"
                target="_blank"
                >here</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >Where can I find out more about the Everyday Rewards Plus
              Card?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              Full details of the Everyday Rewards Plus Card, including full
              Terms and Conditions, can be accessed via the Team Benefits
              Portal at
              <a href="https://teambenefits.woolworths.com.au" target="_blank"
                >teambenefits.woolworths.com.au</a
              >.
            </p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title
              >What are my obligations as a Everyday Rewards Plus
              cardholder?</mat-panel-title
            >
          </mat-expansion-panel-header>
          <div>
            <p>
              <b>Answer:</b><br />
              It is your responsibility to ensure that the Everyday Rewards
              Plus Card is used in line with the Everyday Rewards Plus Card
              Terms &amp; Conditions and Everyday Rewards Terms and
              Conditions. Important things to note:
            </p>
            <ul>
              <li>
                The Everyday Rewards Plus Card must not be used to obtain a
                discount for anyone other than the cardholder, and cannot be
                used to purchase goods for resale.
              </li>
              <li>
                The card should only be used by the person whose details
                appear on the card.
              </li>
              <li>
                Proof of identification may be requested at the point of sale.
                If identification is not provided, the discount may not be
                applied. Everyday Rewards Plus Cards may be confiscated at the
                point of sale if presented by an unauthorised person.
              </li>
              <li>
                Misuse of the Everyday Rewards Plus Card may result in the
                card being confiscated and/or the Team Member no longer being
                eligible to receive this benefit. Misuse of the Everyday
                Rewards Plus Card may also result in disciplinary action being
                taken against the Primary cardholder (i.e. the Team Member),
                which may include termination of the Team Member’s employment.
              </li>
              <li>
                The Everyday Rewards Plus Card is the property of Woolworths
                Group Limited. The Primary Card and any Secondary Card must be
                returned to Woolworths or if directed, destroyed by the
                cardholder when the Team Member ends employment with
                Woolworths.
              </li>
            </ul>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    </div>
</div>
